export function getDeliveryTimingPermissions(deliveryTimingConfig) {
  if (!deliveryTimingConfig) {
    return null;
  }

  return deliveryTimingConfig.permissions ?? deliveryTimingConfig;
}

export function isScanningCodesEnabled(deliveryTimingConfig) {
  const permissions = getDeliveryTimingPermissions(deliveryTimingConfig);
  return !!permissions?.scanning_codes_enabled;
}

/** Show QR / scan-code actions when scanning is on and manual marking is off. */
export function shouldShowScanCodes(deliveryTimingConfig) {
  const permissions = getDeliveryTimingPermissions(deliveryTimingConfig);
  if (!permissions) {
    return false;
  }

  return (
    !!permissions.scanning_codes_enabled && !permissions.allow_manual_orders_marking
  );
}

export function shouldShowScanCodesForHandover(handover) {
  if (!handover) {
    return false;
  }

  if (shouldShowScanCodes(handover.delivery_timing_config)) {
    return true;
  }

  if (shouldShowScanCodes(handover.PickupTour?.delivery_timing_config)) {
    return true;
  }

  return (handover.Orders || []).some((order) =>
    shouldShowScanCodes(order.delivery_timing_config)
  );
}
